$(function () {
    $(".tabslider").each(function () {
        var sliderNav = $(this).find('.tabslider-nav-items');
        var sliderPanel = $(this).find('.tabslider-panel-items');
        sliderNav.slick({
            fade: false,
            dots: false,
            infinite: false,
            variableWidth: true,
            slidesToScroll: 1,
            arrows: false,
            variableWidth: true,
            asNavfor: sliderPanel,
            accessibility: false,
        });
        sliderPanel.slick({
            fade: true,
            dots: false,
            infinite: false,
            slidesToScroll: 1,
            arrows: false,
            asNavfor: sliderNav,
            accessibility: false,
        });
    })

    $(".tabSlideTab").on("click", function (e) {
        e.preventDefault();
        var slickIndex = $(this).parents('.slick-slide').attr('data-slick-index');
        slickIndex = parseInt(slickIndex);
        $('.tabslider-nav-items').slick('slickGoTo', slickIndex);
        $('.tabslider-panel-items').slick('slickGoTo', slickIndex);
    });
    $(".tabSlidePrev").on("click", function (e) {
        e.preventDefault();
        var slickIndex = $(this).parents('.slick-slide').attr('data-slick-index');
        slickIndex = parseInt(slickIndex);
        $('.tabslider-nav-items').slick('slickGoTo', slickIndex - 1);
        $('.tabslider-panel-items').slick('slickGoTo', slickIndex - 1);
    });
    $(".tabSlideNext").on("click", function (e) {
        e.preventDefault();
        var slickIndex = $(this).parents('.slick-slide').attr('data-slick-index');
        slickIndex = parseInt(slickIndex);
        $('.tabslider-nav-items').slick('slickGoTo', slickIndex + 1);
        $('.tabslider-panel-items').slick('slickGoTo', slickIndex + 1);
    });
});